module.exports = __webpack_public_path__ + "static/img/MS03.569bbcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/MS03.jpg
// module id = RmrW
// module chunks = 9